import { render, staticRenderFns } from "./AllowanceTipsV2.vue?vue&type=template&id=5f495aaa&scoped=true&"
import script from "./AllowanceTipsV2.vue?vue&type=script&lang=js&"
export * from "./AllowanceTipsV2.vue?vue&type=script&lang=js&"
import style0 from "./AllowanceTipsV2.vue?vue&type=style&index=0&id=5f495aaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f495aaa",
  null
  
)

export default component.exports